/**
 * In-code fallback for appConfig/helpVideos when the document is absent.
 *
 * Deliberately EMPTY: with no doc (prod today) the Videos entry is hidden —
 * no "coming soon" placeholder. Dev and demo are seeded with real entries
 * (scripts/seedHelpVideos.js, scripts/seedDemoData.js). Shape: see README.md.
 */
export const DEFAULT_HELP_VIDEOS = Object.freeze([]);
